import React from 'react';
import store from '../store';
import FloatButton from '../components/FloatButton';
//import CardContent from '../components/CardContent';
import Toolbar from '../components/Toolbar';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import  FormControl  from '@material-ui/core/FormControl';
import Button  from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';
import GroupWorkIcon from '@material-ui/icons/Group';
import ReceiptIcon from '@material-ui/icons/Receipt';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import { Redirect } from 'react-router-dom';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import AddIcon from '@material-ui/icons/Add';
import TextField from '@material-ui/core/TextField';
import moment from "moment";
import Modal from '@material-ui/core/Modal';
import { NotificationManager} from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuItem from '@material-ui/core/MenuItem';
import XLSX from 'xlsx';
import _ from 'lodash';
import * as STATIC from '../config/static';
var FileSaver = require('file-saver');
 function s2ab(s) {
var buf = new ArrayBuffer(s.length);
var view = new Uint8Array(buf);
for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
return buf;
}
const DWIDTH = 640;

if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
const styles = theme => ({
    title: {
        marginBottom: theme.spacing.unit * 2,
        padding: 0
    },
    search: {
        backgroundColor: '#fff',
        padding: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 2,
        borderRight: 'solid 1px #ededed',
        borderLeft: 'solid 1px #ededed',
        borderTop: 'solid 1px #ededed'
    },
    buttonAdd: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },group_list:{
      border:"1px solid gray",
      display:'flex',
      flexDirection:'column'
    },
    group_list_item:{
      textAlign:'center',
      border:"1px solid gray",
      padding:5,
      display:'flex',
      flexDirection:'column',
      justifyContent:'center',
      alignItems:'center'
    }
    ,
    group_list_input:{
      textAlign:'center',
      border:"none",
      background:'transparent',
      width: '100%',
      height: '100%',
    },
});

function a(q, f) {
    try {
        if (q.toLowerCase().includes(f)) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
}


class AdminCourse extends React.Component {
    constructor() {
        super();
        this.state = { search: '',setting:null,item:{},contents:[],open:false,openPractice:false,top:10,type:"Basic"};

    }

    async loadSettings(){
      console.log('load Setting');
      let _this = this;
      let doc = await firebase.firestore().collection('settings').doc("background").get();

      if(doc.exists)
      {
        let setting = doc.data();
        setting.id = doc.id;
        console.log(setting);
        _this.setState({setting});
      }

    }
    // loadDataCoures(){
    //   console.log('load Data Courses');
    //   let _this = this;
    //   firebase.firestore().collection('data_courses').where("enable","==",1).orderBy('ten').get().then((data)=>{
    //     let DATA_COURSES = [];
    //     data.forEach((doc)=>{
    //       let item = doc.data();
    //       //item.id=doc.id;
    //       DATA_COURSES.push(item);
    //     })
    //
    //     _this.setState({DATA_COURSES});
    //     store.dispatch({ type: 'DATA_COURSES', DATA_COURSES });
    //   })
    //
    // }
    componentDidMount(){
      //this.loadContents();
      //this.loadDataCoures();
      this.loadSettings();
    }
    componentWillUnmount(){
      if(this.state.sub)
      this.state.sub();
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };
    handleChangeEndDate =  event => {
      let endTime = moment(event.target.value).endOf("days").valueOf();
        let setting = this.state.setting;
        setting.endTime = endTime;
        this.setState({
            setting
        });
    };
    handleChangeStartDate =  event => {
      let startTime = moment(event.target.value).startOf("days").valueOf();
        let setting = this.state.setting;
        setting.startTime = startTime;
        this.setState({
            setting
        });
    };
    handleClose = value => {
        this.setState({ open: false });
    };
    handleClosePractice = value => {
        this.setState({ openPractice: false });
    };
    handleClickOpen = () => {
            this.setState({
                open: true,
            });
        };
        handleClickOpenPractice= () => {
                this.setState({
                    openPractice: true,
                });
            };
            saveSetting =  event => {
               firebase.firestore().collection('settings').doc("background").update({...this.state.setting});
               NotificationManager.success("Success!");
            };
            addReward =  event => {
              let setting = this.state.setting;
              if(!setting.rewards)
              setting.rewards = [];
              setting.rewards.push({code:"",name:"",day:7});
              this.setState({
                  setting
              });
            };
            removeReward = (index) =>  event => {
              let setting = this.state.setting;

              setting.rewards.splice(index,1);
              this.setState({
                  setting
              });
            };
            onItemChange = (value,item,key)=>{
              if((key=="pc"||key=="app"))
              {
                if((!value||value.trim().length==0))
                value="https://app.superbrain.edu.vn/assets/web/bg_new_2.jpg";
                else {
                  let t = value.split("file/d/");
                  if(t.length>1)
                  {
                    t = t[1].split("/");
                    value="https://drive.google.com/uc?export=view&id="+t[0];

                  }
                }
              }
              item[key]=value;
              this.forceUpdate();
            }
            exportByDay = async (item,cIndex)=>{
              //await this.setState({loading:true})
              if(item.day>0)
              {
                await this.setState({loading:true})
                let data = await firebase.firestore().collection('data_students').where("MarathonTDay",">=",item.day).get();
                if(data.size>0)
                {
                  let sArr = [];
                  data.forEach(doc=>{
                    sArr.push(doc.data())
                  })
                  sArr = _.sortBy(sArr,['mahs'],['asc']);
                  let headers = ["STT","Mã Chi Nhánh","Mã HV","Họ và Tên","Số ngày online liên tục","Số ngày nghỉ","Ngày online hiện tại","Ngày online lần cuối","Quà Tặng"];
                  let csvData = [headers];
                  let index = 1;
                  let dRewards = [];
                  let dRewardsName = [];
                  for(let i=0;i<=cIndex;i++)
                  {
                    let t= _.cloneDeep(this.state.setting.rewards[i]);
                    dRewards.push(t);
                    dRewardsName.push(t.name);
                  }
                  for(let i of sArr)
                  {
                    let macn = i.idchinhanh;
                    let tArr = i.mahs.split("-");
                    if(tArr.length>0)
                    macn = tArr[0];
                    let reward = dRewardsName.join(",");
                    csvData.push([index,macn,i.mahs,i.ten,i.MarathonTDay,i.MarathonOffDay,i.MarathonCDay,moment(i.MarathonLast).format("DD/MM/YYYY"),reward])
                  }
                  // console.log(csvData);
                  // _this.setState({csvData,downloadCSV:true});
                  var wb = XLSX.utils.book_new();
                  let filename = "Marathon - "+item.day;
                  wb.SheetNames.push(filename);
                  var ws = XLSX.utils.aoa_to_sheet(csvData);
                  wb.Sheets[filename] = ws;
                  var contents = XLSX.write(wb, {bookType: 'xlsx',bookSST: true, cellStyles: true, type: 'binary'});
                  var blob = new Blob([s2ab(contents)], {type: "application/octet-stream"});
                  FileSaver.saveAs(blob, filename+"_"+moment().format('YYYYMMDDHHmmss')+".xlsx");
                }
                else {
                  NotificationManager.error("Not Found!");
                }
                await this.setState({loading:false})
                console.log(data.size);
              }
              else
              NotificationManager.error("Day must be greater than 0!");
            }
            exportByType = async ()=>{
              //await this.setState({loading:true})
              await this.setState({loading:true})
              let {type,top} = this.state;
                let ref = firebase.firestore().collection('Marathon');
                if(type!="all")
                {
                  ref = ref.where("type","==",type);
                }
                ref = ref.orderBy("rows","desc").limit(top);
                let data = await ref.get();
                if(data.size>0)
                {
                  let sArr = [];
                  data.forEach(doc=>{
                    sArr.push(doc.data())
                  })
                  //sArr = _.sortBy(sArr,['mahs'],['asc']);
                  let headers = ["STT","Chi Nhánh","Mã HV","Họ và Tên","Số Hàng","Loại"];
                  let csvData = [headers];
                  let index = 1;
                  for(let i of sArr)
                  {
                    let macn = i.mahs;
                    let tArr = i.mahs.split("-");
                    if(tArr.length>0)
                    macn = tArr[0];
                    if(i.tencn)
                    macn=i.tencn;
                    csvData.push([index,macn,i.mahs,i.name,i.rows,i.type]);
                    index++;
                  }
                  // console.log(csvData);
                  // _this.setState({csvData,downloadCSV:true});
                  var wb = XLSX.utils.book_new();
                  let filename = "Marathon - "+type+"_top"+top;
                  wb.SheetNames.push(filename);
                  var ws = XLSX.utils.aoa_to_sheet(csvData);
                  wb.Sheets[filename] = ws;
                  var contents = XLSX.write(wb, {bookType: 'xlsx',bookSST: true, cellStyles: true, type: 'binary'});
                  var blob = new Blob([s2ab(contents)], {type: "application/octet-stream"});
                  FileSaver.saveAs(blob, filename+"_"+moment().format('YYYYMMDDHHmmss')+".xlsx");
                }
                else {
                  NotificationManager.error("Not Found!");
                }
                await this.setState({loading:false})
                console.log(data.size);
            }
 clearAll = async()=>{
  if(window.confirm("All data will be reset, are you sure?"))
  {
    console.log("call clear all")
    await this.setState({loading:true});
    let res = await STATIC.postFormData(STATIC.API_MARATHON_CLEARDATA,{});
    //console.log(res);
    if(res)
    {
      console.log("success");
      NotificationManager.success("Success!");
    }
    await this.setState({loading:false});
  }
}


    render() {
        const { classes } = this.props;
        const { search,contents,setting,loading } = this.state;

        const item_button =  { name:"", startDate: '',endDate:'',week:4,course_id:0,created:(new Date()).getTime() };
        // if(!store.getState().ADMINACCOUNT)
        // {
        //   console.log('No Admin');
        //   return <Redirect to='/sbadmin' />
        // }
        return (
          <div>
          <Toolbar/>
            <div style={{ maxWidth: '720px',margin: '20px auto',paddingTop: '64px'}}>
                <Grid justify="flex-start" direction="row" container>
                    <Grid item><AllInboxIcon style={{ marginRight: 10 }} /></Grid>
                    <Grid item><Typography variant="title" className={classes.title}>Settings</Typography></Grid>
                </Grid>
                <Grid justify="flex-start" container>

                  <Grid item xs={12}>
                    {setting&&<div className={classes.group_list}>
                          <div style={{display:'flex',flexDirection:'row'}}>

                            <div className={classes.group_list_item} style={{width:'30%'}}>Name</div>
                            <div className={classes.group_list_item} style={{width:'70%'}}>Link</div>
                        </div>
                        <div  style={{display:'flex',flexDirection:'row'}}>
                          <div className={classes.group_list_item} style={{width:'30%'}}>PC</div>
                          <div className={classes.group_list_item} style={{width:'70%'}}><input className={classes.group_list_input} onChange={(e)=>this.onItemChange(e.target.value,setting,'pc')} type="text" value={setting.pc}/></div>


                    </div>
                    <div  style={{display:'flex',flexDirection:'row'}}>
                      <div className={classes.group_list_item} style={{width:'30%'}}>App</div>
                      <div className={classes.group_list_item} style={{width:'70%'}}><input className={classes.group_list_input} onChange={(e)=>this.onItemChange(e.target.value,setting,'app')} type="text" value={setting.app}/></div>


                </div>


                      </div>}

                  </Grid>



                </Grid>

                <Button onClick={this.saveSetting} variant="contained" color="secondary" aria-label="add">
                    Save
                </Button>





                </div>
                <div>


                            </div>
                            <Modal
        open={loading}
        onClose={() => this.setState({ loading: false })}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
      <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{textAlign:'center'}}>
      <CircularProgress style={{color:'white'}}/>
      </div>
    </div>
      </Modal>

            </div>
        )
    }
}

AdminCourse.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminCourse);
